import dedent from 'dedent';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { BreOrderType } from '~/tenants/bre/model/enums';
import BreBoostConfig from '~/tenants/bre/performable/boost/BreBoostConfig';
import BreCinematicConfig from '~/tenants/bre/performable/cinematic/BreCinematicConfig';
import BreFloorplanConfig from '~/tenants/bre/performable/floorplan/BreFloorplanConfig';
import BrePhotosConfig from '~/tenants/bre/performable/photos/BrePhotosConfig';
import BreWebsiteConfig from '~/tenants/bre/performable/website/BreWebsiteConfig';
import { TenantPackageConfig } from '~/tenants/common/registry';

const BreCinematicsPackageConfig: TenantPackageConfig<BreOrderContext> = {
  id: 'cinematic_package',
  name: 'Cinematic Video',
  percentage: 0.1,
  performables: [
    BreCinematicConfig,
    BrePhotosConfig,
    BreFloorplanConfig,
    BreWebsiteConfig,
    BreBoostConfig,
  ],
  eligible: ({ metadata }) => metadata.type === BreOrderType.RESIDENTIAL,
  description: dedent`
    Includes our ground photography, a 2D Floor Plan, a cinematic video with a \
    free social media video edit, social media boost, and a single property \
    website page.
  `,
};

export default BreCinematicsPackageConfig;
